import {
  Col,
  Row,
  message,
  Popconfirm,
  Space,
  Typography,
  Form,
  Button,
  Input,
  Divider,
} from "antd"
import React from "react"
import { addDoc, collection, deleteDoc, doc, serverTimestamp, setDoc } from "firebase/firestore"
import { db } from "../../../firebase/config"
import { useCollection } from "../../../hooks/useCollection"
import PageHeader from "../../../components/Elements/PageHeader"
import StandartTable from "../../../components/Elements/StandartTable"
import { PiFactory } from "react-icons/pi"
import EditManufacturerDrawer from "./EditManufacturerDrawer"

const { Link, Text } = Typography

export default function Manufacturers() {
  const { data, loading } = useCollection("manufacturers")
  const [form] = Form.useForm()

  //Delete material
  const deleteSupplier = async (e, docid) => {
    e.preventDefault()
    const ref = doc(db, "manufacturers", docid)
    try {
      await deleteDoc(ref).then(() => {
        message.success("Deleted!")
      })
    } catch (err) {
      message.success(err.message)
    }
  }

  const onFinish = (values) => {
    console.log("Success:", values)
    createManufacturer(values)
  }
  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo)
  }

  //default columns for table
  const supplierColumns = [
    {
      title: "Company name",
      dataIndex: "company",
      align: "center",
    },
    {
      title: "Comment",
      dataIndex: "comment",
      align: "center",
      // render: (val, rec) => <button onClick={() => console.log(rec)}>log</button>,
    },

    {
      title: "Action",
      align: "center",
      render: (value, record) => (
        <>
          <Space split>
            <Popconfirm
              title="Are you sure？"
              placement="left"
              onConfirm={(event) => deleteSupplier(event, value.id)}
              okText="Yes"
              cancelText="No">
              <Link style={{ color: "red" }}>delete</Link>
            </Popconfirm>
            <EditManufacturerDrawer data={record} />
          </Space>
        </>
      ),
    },
  ]

  const createManufacturer = async (data) => {
    // ref for manufacturers
    const ref = collection(db, "manufacturers")

    //proforma id + prefix
    const proRef = "PRO" + data.invoicePrefix

    try {
      await addDoc(ref, data)
        .then(() => {
          //also adds a sequence doc
          setDoc(doc(db, "sequence", data.invoicePrefix), {
            company: data.company,
            invoiceNumberBeforeLast: 0,
            lastHronoId: 0,
            lastInvoiceId: "qwer",
            lastInvoiceNumber: 1,
            updated: serverTimestamp(),
          })
        })
        .then(() => {
          //also adds a sequence doc for Proformas
          setDoc(doc(db, "sequence", proRef), {
            company: data.company,
            invoiceNumberBeforeLast: 0,
            lastHronoId: 0,
            lastInvoiceId: "qwer",
            lastInvoiceNumber: 1,
            updated: serverTimestamp(),
          })
        })
        .then(() => {
          message.success(`Success! Manufacturer has been created.`)
        })
        .then(() => {
          form.resetFields() // Reset form fields after the data is successfully added
        })
    } catch (err) {
      message.error(err.message)
    }
  }

  return (
    <div style={{ padding: 15 }}>
      <Row gutter={[15, 15]}>
        <Col span={24}>
          <PageHeader icon={<PiFactory />} text="Manufacturers" />
        </Col>
        <Col span={16}>
          <StandartTable loading={loading} data={data} columns={supplierColumns} />
        </Col>
        <Col span={8}>
          <Divider>Create Manufacturer</Divider>
          <Form
            form={form}
            name="create-manufacturer"
            size="small"
            style={{ width: "100%", padding: 25 }}
            layout="horizontal"
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
            autoComplete="off">
            <Form.Item
              label="Manufacturer Company"
              name="company"
              rules={[
                {
                  required: true,
                  message: "Please input your username!",
                },
              ]}>
              <Input placeholder="Manufacturer company" />
            </Form.Item>
            <Form.Item
              label="Vat Number"
              name="vat"
              rules={[
                {
                  required: true,
                  message: "Please input your vat!",
                },
              ]}>
              <Input placeholder="vat" />
            </Form.Item>
            <Form.Item
              label="Reg Number"
              name="reg"
              rules={[
                {
                  required: true,
                  message: "Please input your reg!",
                },
              ]}>
              <Input placeholder="reg" />
            </Form.Item>
            <Divider>
              <Text style={{ fontSize: 14 }}> Legal Address</Text>
            </Divider>
            <Form.Item
              label="Legal city"
              name="legalCity"
              rules={[
                {
                  required: true,
                  message: "Riga",
                },
              ]}>
              <Input placeholder="Legal city" />
            </Form.Item>
            <Form.Item
              label="Legal postal code"
              name="legalPC"
              rules={[
                {
                  required: true,
                  message: "Please input your PC!",
                },
              ]}>
              <Input placeholder="LV-1003" />
            </Form.Item>
            <Form.Item
              label="Legal address"
              name="legalAddress"
              rules={[
                {
                  required: true,
                  message: "Please input your PC!",
                },
              ]}>
              <Input placeholder="Jelgavas iela 5b" />
            </Form.Item>

            <Divider>
              <Text style={{ fontSize: 14 }}> Delivery Address</Text>
            </Divider>

            <Form.Item
              label="Delivery City"
              name="deliveryCity"
              rules={[
                {
                  required: true,
                  message: "Riga",
                },
              ]}>
              <Input placeholder="Delivery city" />
            </Form.Item>
            <Form.Item
              label="Delivery postal code"
              name="deliveryPC"
              rules={[
                {
                  required: true,
                  message: "Please input your PC!",
                },
              ]}>
              <Input placeholder="LV-1005" />
            </Form.Item>
            <Form.Item
              label="Delivery address"
              name="deliveryAddress"
              rules={[
                {
                  required: true,
                  message: "Please input your PC!",
                },
              ]}>
              <Input placeholder="Brīvības iela 61b" />
            </Form.Item>

            <Divider>
              <Text style={{ fontSize: 14 }}> Bank Details</Text>
            </Divider>

            <Form.Item
              label="Bank Name"
              name="bankName"
              rules={[
                {
                  required: true,
                  message: "Please input your bank name!",
                },
              ]}>
              <Input placeholder="AS 'SEB banka'..." />
            </Form.Item>

            <Form.Item
              label="Bank Code"
              name="bankCode"
              rules={[
                {
                  required: true,
                  message: "Please input your code!",
                },
              ]}>
              <Input placeholder="UNLALV2X..." />
            </Form.Item>

            <Form.Item
              label="Account number"
              name="accountNumber"
              rules={[
                {
                  required: true,
                  message: "Please input your acc number!",
                },
              ]}>
              <Input placeholder="LV95UNLA00500007506..." />
            </Form.Item>
            <Form.Item
              label="Invoice prefix"
              name="invoicePrefix"
              rules={[
                {
                  required: true,
                  message: "Please input your acc number!",
                },
              ]}>
              <Input placeholder="AL" />
            </Form.Item>

            <Divider>
              <Text style={{ fontSize: 14 }}> Comment</Text>
            </Divider>

            <Form.Item
              rules={[
                {
                  required: true,
                  message: "Please input your acc number!",
                },
              ]}
              name="comment"
              label="Comment">
              <Input.TextArea name="comment" rows={2} placeholder="Manufacturer comment" />
            </Form.Item>

            <Form.Item>
              <Button block type="primary" htmlType="submit">
                Submit
              </Button>
            </Form.Item>
          </Form>
        </Col>
      </Row>
    </div>
  )
}
